import { FaListAlt } from "react-icons/fa";
import { FaCar } from "react-icons/fa";
import { MdPayments } from "react-icons/md";
import { GoSettings } from "react-icons/go";
import { useLocation, useNavigate } from "react-router-dom";

export default function NavigationBar() {
  const location = useLocation();
  const navigate = useNavigate();

  // Get page address from url
  const selected = location.pathname.slice(1).split("/")[0] || "general";

  /* ======================= ICON CLASSES ======================= */
  const iconClasses = (icon) => {
    let classes = "icon";
    if (icon === selected) classes += " text-yellow-600";
    return classes;
  };

  return (
    <div className="container grid-cols-4 gap-4 md:hidden justify-items-center">
      <FaListAlt
        className={iconClasses("general")}
        onClick={() => navigate("/general")}
      />

      <FaCar
        className={iconClasses("vehicles")}
        onClick={() => navigate("/vehicles")}
      />

      <MdPayments
        className={iconClasses("payments")}
        onClick={() => navigate("/payments")}
      />

      <GoSettings
        className={iconClasses("settings")}
        onClick={() => navigate("/settings")}
      />
    </div>
  );
}
